import { render, staticRenderFns } from "./DeviceFaultType.vue?vue&type=template&id=bc81a89a&scoped=true"
import script from "./DeviceFaultType.vue?vue&type=script&lang=js"
export * from "./DeviceFaultType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc81a89a",
  null
  
)

export default component.exports